import { Navigate } from '@tanstack/react-router'

export const Route = createFileRoute({
  component: () => <Navigate to="/" replace />,
})
